interface BuildChatBotInstallationSnippetsOptions {
  token: string;
  chatbotUrl: string;
}

/**
 * Compiles all installation code snippets for a chatbot widget.
 */
export const buildChatBotInstallationSnippets = ({
  token,
  chatbotUrl,
}: BuildChatBotInstallationSnippetsOptions) => {
  const webScript = [
    `<script>`,
    `  (function () {`,
    `    function onLoad() {`,
    `      var script = document.createElement("script");`,
    `      script.src = "${chatbotUrl}/bot.min.js";`,
    `      script.async = true;`,
    `      script.setAttribute("data-token", "${token}");`,
    `      script.setAttribute("data-chatbot-url", "${chatbotUrl}");`,
    `      document.body.appendChild(script);`,
    `    }`,
    ``,
    `    if (document.readyState === "complete") {`,
    `      onLoad();`,
    `    } else {`,
    `      window.addEventListener("load", onLoad);`,
    `    }`,
    `  })();`,
    `</script>`,
  ].join("\n");

  const mobileUrlParams = new URLSearchParams({
    token,
    mobile: "true",
  });

  const mobileUrl = `${chatbotUrl}/?${mobileUrlParams.toString()}`;

  const mobileCode = [
    `// Load this URL in your mobile WebView`,
    `const chatbotUrl = "${mobileUrl}";`,
    `webView.loadUrl(chatbotUrl);`,
  ].join("\n");

  return { webScript, mobileUrl, mobileCode };
};
